import { QuoteStatus } from 'types/quote';

export const INVALID_STATUSES: QuoteStatus[] = ['invalid', 'expired', 'declined', 'canceled'];
export const VALID_STATUSES: QuoteStatus[] = ['init', 'accepted', 'applicationCompleted', 'rented', 'rentCompleted', 'rentCanceled'];
export const PRIORITY_STATUSES: QuoteStatus[] = [
  'rentCompleted',
  'rentCanceled',
  'rented',
  'accepted',
  'applicationCompleted',
  'init',
  'suspended',
  'declined',
  'expired',
  'invalid',
];
export const DELETABLE_QUOTE_STATUSES: QuoteStatus[] = ['expired', 'invalid', 'suspended', 'init'];
export const SELECTED_QUOTE_STATUSES: QuoteStatus[] = ['accepted', 'rented', 'rentCompleted', 'rentCanceled'];
